var registerComponent = require('../core/component').registerComponent;
var THREE = require('../lib/three');
var utils = require('../utils/');
var warn = utils.debug('components:gltf-model:warn');

/**
 * glTF model loader.
 */
module.exports.Component = registerComponent('gltf-model', {
  schema: { type: 'model' },

  boundingBox: new THREE.Box3(),
  boundingSphere: new THREE.Sphere(),

  init: function () {
    var dracoLoader = this.system.getDRACOLoader();
    this.model = null;
    this.loader = new THREE.GLTFLoader();
    if (dracoLoader) {
      this.loader.setDRACOLoader(dracoLoader);
    }
    if (
      !this.el.hasAttribute('auto-scalling-done') &&
      !this.el.hasAttribute('disable-auto-scale')
    ) {
      this.el.addEventListener('model-loaded', () => {
        const object = this.el.object3D;
        object.updateMatrixWorld();
        this.boundingBox.setFromObject(object);
        this.boundingBox.getBoundingSphere(this.boundingSphere);
        const diameter = this.boundingSphere.radius * 2;
        if ((diameter > 1000 || diameter < 0.1) && diameter !== 0) {
          // Scale models that are too big or to small to fit in a 1m bounding sphere.
          const scaleFactor = 1 / diameter;

          object.scale.set(scaleFactor, scaleFactor, scaleFactor);
        } else if (diameter > 20) {
          // If the bounding sphere of a model is over 20m in diameter, assume that the model was
          // exported with units as centimeters and convert to meters.
          object.scale.set(0.01, 0.01, 0.01);
        }
      });
      this.el.setAttribute('auto-scalling-done', true);
    }
  },

  update: function () {
    var self = this;
    var el = this.el;
    var src = this.data;

    if (!src) {
      return;
    }
    //  if the source is google-poly use the hatch proxy
    if (src.includes('poly.googleapis')) {
      src = `https://api.hatchxr.com/api/proxy?url=${src}`;
    }
    this.remove();
    this.loader.load(
      src,
      function gltfLoaded(gltfModel) {
        self.model = gltfModel.scene || gltfModel.scenes[0];
        self.model.animations = gltfModel.animations;
        if (el.getAttribute('autoscale') == null) {
          var bbox = new THREE.Box3().setFromObject(self.model);
          var span = 3;
          var scale = span / bbox.getSize().length();
          self.model.scale.set(scale, scale, scale);
          bbox = new THREE.Box3().setFromObject(self.model);
          var x = (bbox.min.x + bbox.max.x) / 2;
          var y = (bbox.min.y + bbox.max.y) / 2;
          var z = (bbox.min.z + bbox.max.z) / 2;
          const geometry = new THREE.BoxBufferGeometry(1, 1, 1);
          var pivot = new THREE.Mesh(geometry);
          self.model.position.set(x * -1, y * -1, z * -1);
          pivot.add(self.model);
          el.setObject3D('mesh', pivot);
          // el.emit('model-loaded', { format: 'gltf', model: pivot });
        }
        el.setObject3D('mesh', self.model);
        el.emit('model-loaded', { format: 'gltf', model: self.model });
      },
      undefined /* onProgress */,
      function gltfFailed(error) {
        var message =
          error && error.message ? error.message : 'Failed to load glTF model';
        warn(message);
        el.emit('model-error', { format: 'gltf', src: src });
      }
    );
  },

  remove: function () {
    if (!this.model) {
      return;
    }
    this.el.removeObject3D('mesh');
  },
});
